<template>
  <div class="map">
    <GMapAutocomplete
      class="form-control"
      @place_changed="setPlace"
      :disabled="type == 'read'"
      :value="getaddress"
      required
      @keypress.enter="$event.preventDefault()"
    >
    </GMapAutocomplete>
    <GMapMap :center="center" :zoom="zoom" :key="getaddress">
      <GMapCluster :zoomOnClick="true">
        <GMapMarker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :clickable="true"
          :draggable="true"
          @click="center = m.position"
        />
      </GMapCluster>
    </GMapMap>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        center: { lat: 41.5911589, lng: 1.5208624 },
        zoom: 7,
        markers: [],
      }
    },
    props: {
      type: {
        type: String,
        default: '',
      },
      getaddress: {
        type: String,
        default: '',
      },
      getmarkers: {
        type: Object,
        default: {},
      },
    },
    emits: ['updateMap'],

    methods: {
      setPlace(place) {
        this.markers = [
          {
            position: {
              lat: place.geometry.location.lat(),
              lng: place.geometry.location.lng(),
            },
          },
        ]
        this.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        }
        this.zoom = 13
        if (this.markers[0]) {
          this.$emit('updateMap', {
            coords: this.markers[0],
            address: place.formatted_address,
          })
        }
      },
    },
    created() {
      if ((this.type == 'edit' || this.type == 'read') && this.getmarkers) {
        this.zoom = 13
        this.center = {
          lat: this.getmarkers.position.lat,
          lng: this.getmarkers.position.lng,
        }
        this.markers = [
          {
            position: {
              lat: this.getmarkers.position.lat,
              lng: this.getmarkers.position.lng,
            },
          },
        ]
      }
    },
  }
</script>

<style scoped>
  .vue-map-container {
    height: 100%;
  }
  .map {
    height: 300px;
  }
</style>
